import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './NewMain.css';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Selection,
  Inject,
  Toolbar,
  ColumnChooser,
  Sort,
  Filter
} from '@syncfusion/ej2-react-grids';

import { poiGrid } from '../../data/dummy';
import { Header } from '../../components';
import CreateAddIcon from '../../data/createAddIcon.png';
import { BASE_URL, deleteCall, get } from '../../Services/Calls';
import { isValidDate } from '../../Services/Utils';
import { setGridVisibility, getGridVisibility } from '../../Services/gridVisibilityHelper';

const POI = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const gridRef = useRef(null);
  const selectionsettings = { persistSelection: true };
  const toolbarOptions = ['Delete', 'Search', 'ColumnChooser'];
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [poiData, setPoiData] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [loading, setLoading] = useState(true);
  const editOptions = {
    allowEditing: false,
    allowAdding: true,
    allowDeleting: true
  };

  const FilterOptions = {
    type: 'Excel'
  };




 const pageKey = 'poi-page'; // unique key for each page
  const [isReady, setIsReady] = useState(false);
  const [columnSettings, setColumnSettings] = useState([]);
useEffect(() => {
    const saved = getGridVisibility(pageKey);
    if (saved) setColumnSettings(saved);

     setIsReady(true);
  }, []);

  



const finalColumns = poiGrid(setLoading).map((col) => {
  if (!col.field) return col; // Skip if no field (like checkbox/template)

  const match = columnSettings?.find((c) => c.field === col.field);
  return match
    ? { ...col, visible: match.visible }    // apply visibility state
    : { ...col };                           // fallback: visible by default
});




 

  useEffect(() => {
    getPoi()
  }, []);

  const getPoi = async () => {
    setLoading(true);
    try {
      const response = await get(BASE_URL + '/pois');
      if (response && response.results && response.results.length > 0) {
        const sortedPois = response.results.sort((a, b) => {
          const dateA = new Date(a.createdAt);
          const dateB = new Date(b.createdAt);
          if (isValidDate(dateA) && isValidDate(dateB)) {
            return dateB - dateA
          } else if (isValidDate(dateA)) {
            return -1;
          } else if (isValidDate(dateB)) {
            return 1;
          } else {
            return 0;
          }
        })

         const saved =  localStorage.getItem("selectedCountry");
        if (saved) {
          const filteredResults = sortedPois.filter(item => String(item.country?.id) === String(saved));
          setPoiData(filteredResults);

        }
        else {
        setPoiData(sortedPois);
        }
        setTimeout(() => {
          filterByUrl()
        }, 500);
      }
    }
    catch (ex) {
      alert(ex);
    }
    finally {
      setLoading(false); 
    }
  }

  const toolbarClick = args => {
    switch (args.item.text) {
      case 'Delete':
        args.cancel = true;
        setDeleteConfirm(true);
        break;
      default:
        break;
    }
  }

  const handleDelete = async () => {
    setLoading(true);
    setDeleteConfirm(false);
    try {
      for (let i = 0; i < selectedRecords.length; i++) {
        const response =await deleteCall(
           BASE_URL + '/pois/' + selectedRecords[i].id
        );
        if (response) {

        }
      }
        
        getPoi();
      

    } catch (ex) {
      alert(ex)
    }
  }

  let grid;

  const rowSelected = () => {
    if (gridRef.current) {
      setSelectedRecords(gridRef.current.getSelectedRecords());
    }
  }

  const rowDeselected = args => {
    let tempSelectedRecords = [...selectedRecords]
    for (let i = 0; i < tempSelectedRecords.length; i++) {
      if (args.data.length > 1) {
        for (let j = 0; j < args.data.length; j++) {
          if (tempSelectedRecords[i].id === args.data[j].id) {
            tempSelectedRecords.splice(i, 1);
          }
        }
      } else {
        if (tempSelectedRecords[i].id === args.data.id) {
          tempSelectedRecords.splice(i, 1);
        }
      }
    }
    setSelectedRecords(tempSelectedRecords);
  }


//for add filter in url


const onActionComplete = (args) => {
  if (args.requestType === "filtering") {
    const gridObj = gridRef.current;
    const filters = gridObj.filterSettings.columns.map((col) => ({
      field: col.field,
      operator: col.operator,
      value: col.value,
      matchCase: col.matchCase,
      predicate: col.predicate || 'and', // default predicate if missing
    }));

    // Convert filters to URL parameters
    const params = new URLSearchParams();

    filters.forEach((filter) => {
      if (filter.value) {
        params.append(filter.field, filter.value);
      }
    });

    // Update the URL with the new filter parameters
    if (params.toString()) {
      navigate(`?${params.toString()}`, { replace: true });
    }
    else {
      // ✅ If no filters exist, reset the URL (remove query parameters)
      navigate(window.location.pathname, { replace: true });
    }
  }
  if (args.requestType === 'columnstate') {
      const gridCols = gridRef.current?.getColumns() ?? [];
      const state = gridCols
        .filter((c) => !!c.field)
        .map((c) => ({
          field: c.field,
          visible: c.visible,
        }));
      setGridVisibility(pageKey, state);
    }
};





const filterByUrl = () => {
  if (!gridRef.current) return;

  if (location.search) {
    const params = new URLSearchParams(location.search);
    const filtersMap = new Map();

    // Convert URL params into structured filters
    for (const [key, value] of params.entries()) {
      if (!filtersMap.has(key)) {
        filtersMap.set(key, []);
      }
      filtersMap.get(key).push(value);
    }

    const filters = [];
    filtersMap.forEach((values, field) => {
      values.forEach((value) => {
        filters.push({
          field,
          operator: "contains",
          predicate: "or", // Default operator for multiple filters
          value,
          matchCase: false,
        });
      });
    });

    // Set filters to grid and ensure the predicate is set
    if (filters.length > 0) {
      gridRef.current.filterSettings = { columns: filters };
      gridRef.current.refresh();
      if (gridRef.current && gridRef.current.filterSettings.columns) {
        // Clean up any invalid filters with missing fields or invalid predicates
        gridRef.current.filterSettings.columns = gridRef.current.filterSettings.columns.filter(
          (col) => col && col.field && col.predicate
        );
      }
     
    }
  }
}


useEffect(() => {
  if (!gridRef.current) return;

  
  if (!location.search) {
    if (!gridRef.current) return;

    // Reset the filterSettings to clear all filters
    gridRef.current.filterSettings = { columns: [] };
  
    // Refresh the grid to apply the reset filter settings
    gridRef.current.refresh();
  }
}, [location.search]);




  return (
    <div className='m-2 ml-10 mr-10 mt-5 p-2 p-5 bg-white rounded-3xl relative'>
      {loading && (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div className="loader ease-linear rounded-full border-4 border-t-4 border-white h-12 w-12 animate-spin"></div>
    </div>
  )}
      <div className='flex justify-between items-center h-20'>
        <Header category='' title={`POIs`} />
        <div
          className='w-100 border flex justify-end items-center mb-8 createBtn'
          onClick={() => {
            navigate('/createPoi', { state: { from: 'create', data: {} } });
          }}
        >
          <span>Create</span>
          <img src={CreateAddIcon} style={{ width: 15, height: 15 }} alt='' />
        </div>
      </div>
{isReady &&
      <GridComponent
        dataSource={poiData}
        enableHover={false}
        allowPaging
        pageSettings={{ pageCount: 3, pageSize: 10 }}
        selectionSettings={selectionsettings}
        toolbarClick={toolbarClick}
        toolbar={toolbarOptions} // Add 'ColumnChooser'
        editSettings={editOptions}
        allowSorting
        filterSettings={FilterOptions}
        allowFiltering={true}
        rowSelected={rowSelected}
        rowDeselected={rowDeselected}
        actionComplete={onActionComplete}
        showColumnChooser={true}
        ref={(g) => (gridRef.current = g)}
      >
        <ColumnsDirective>
          {finalColumns.map((item, index) => (
            <ColumnDirective key={index} {...item}  />
          ))}
        </ColumnsDirective>
        <Inject services={[Page, Selection, Toolbar, Filter, Sort, ColumnChooser]} />
      </GridComponent>
}

      {deleteConfirm && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              width: 400,
              height: 200,
              background: '#fff',
              borderRadius: 10,
              padding: '15px 20px'
            }}
          >
            <div
              style={{
                fontSize: 24,
                fontWeight: 'bold',
                color: '#000',
                marginBottom: 15
              }}
            >
              Delete Alert
            </div>
            <div style={{ fontSize: 18, color: '#000', marginBottom: 10 }}>
              {selectedRecords.length > 0 ? "Are you sure you want to delete selected rows." : "Please select at-least one row."}
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: 20
              }}
            >
              <div
                className='confirmOkBtn'
                onClick={() => {
                  getPoi();
                  setDeleteConfirm(false);
                }}
              >
                {selectedRecords.length > 0 ? "Cancle" : "Ok"}
              </div>
              {selectedRecords.length > 0 &&
                <div
                  className='confirmOkBtn'
                  onClick={() => {
                    handleDelete();
                  }}
                >
                  Yes
                </div>
              }
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default POI;
